import { useMemo } from 'react';
import debounce from 'lodash.debounce';

export default function useDebounce<T = unknown, R = unknown>(callback: (arg?: T) => R, delay: number) {
    const debouncedFn = useMemo(() => debounce((arg?: T) => callback(arg), delay), [delay, callback]);
    return debouncedFn;
}
